import React from 'react';
import { Typography, Box } from '@mui/material';
import Calendar from '../components/Calendar'; // 引入日历组件

export default function DashboardPage() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        仪表盘
      </Typography>
      {/* 在这里渲染日历组件 */}
      <Calendar />

    </Box>
  );
}